import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import style from "css/template.module.css";

function MobileMenuItem({ title, child, to, menuType, setMenuType }) {
    const [isOpen, setIsOpen] = React.useState(false);

    const hasChild = Boolean(child);

    useEffect(() => {
        if (!isOpen && menuType === title) {
            setIsOpen(true);
        } else if (isOpen && menuType !== title) {
            setIsOpen(false);
        }
    }, [isOpen, menuType, setMenuType, title]);

    const onClickMenu = () => {
        if (!isOpen) {
            setMenuType(title);
        } else {
            setMenuType("");
        }
    }

    // 화살표는 펼칠 하위 메뉴가 있을 때만 (About Us 는 하위가 없다)
    const info = (
        <>
            <p>{title}</p>
            {hasChild && (
                <img
                    className={isOpen && style.open}
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                    alt=""
                />
            )}
        </>
    );

    return (
        <li className={style.menu_item}>
            {!hasChild && to ? (
                <Link className={style.menu_info} to={to}>
                    {info}
                </Link>
            ) : (
                <div
                    className={style.menu_info}
                    onClick={hasChild ? () => onClickMenu() : undefined}
                >
                    {info}
                </div>
            )}

            {hasChild && isOpen && <div className={style.menu_child}>{child}</div>}
        </li>
    )
}

export default MobileMenuItem
